import React, { useCallback, useMemo } from 'react';
import { GroupContext, PREFERENCE_TYPE } from '@utils/userPreferencesUtils/Types';
import { useCategoryOrSegmentsLeaderboardGroupEventState } from '../../utils/CategoryOrSegmentsLeaderboardGroupContext';
import { useSharingConfig } from '@services/savedFilter/UseSharingConfig';
import {
  buildNamespace,
  useCategoryLeaderboardGroupState,
  useFeatureLeaderboardGroupState,
} from '@utils/hook/userPreferences/UseGroupState';
import { ShareGroupModal } from '@components/share-group-modal/ShareGroupModal';
import { FeatureOption } from '@utils/pageConfig/Types';
import { AddPreferencePermissionMutateResponse } from '@utils/hook/userPreferences/UseAddPermissionPreferences';
import { GeneralViewState } from '@models/SavedViews';
import { RetailerClient } from '@models/RetailerClient';

export interface Props {
  context: GroupContext;
  saveViewFilter: GeneralViewState;
  retailerClients: RetailerClient[];
}

export const validateCategoryOrSegmentGroup = (currentSelectedFeature: FeatureOption) => {
  return currentSelectedFeature === null || currentSelectedFeature.feature === 'Category'
    ? PREFERENCE_TYPE.categoryLeaderboardGroup
    : PREFERENCE_TYPE.featureLeaderboardGroup;
};

export const ShareCategoryOrSegmentsLeaderboardModalGroup: React.FC<Props> = ({
  context,
  saveViewFilter,
  retailerClients,
}) => {
  const { groupNameToBeDelete, isShareModalGroupPopUp, setIsShareModalGroupPopUp, currentSelectedFeature } =
    useCategoryOrSegmentsLeaderboardGroupEventState();

  const { addPreferencePermissionCategoryLeaderboardGroup } = useCategoryLeaderboardGroupState(context);
  const { addPreferencePermissionFeatureLeaderboardGroup } = useFeatureLeaderboardGroupState(context);

  const selectedGroupingType = validateCategoryOrSegmentGroup(currentSelectedFeature);

  const sharingConfig = useSharingConfig();
  const namespace = buildNamespace(context);

  const addPreferencePermission = useMemo<AddPreferencePermissionMutateResponse<any>>(
    () =>
      selectedGroupingType === PREFERENCE_TYPE.categoryLeaderboardGroup
        ? addPreferencePermissionCategoryLeaderboardGroup
        : addPreferencePermissionFeatureLeaderboardGroup,
    [
      selectedGroupingType,
      addPreferencePermissionCategoryLeaderboardGroup,
      addPreferencePermissionFeatureLeaderboardGroup,
    ],
  );

  const handleClose = useCallback(() => setIsShareModalGroupPopUp(false), [setIsShareModalGroupPopUp]);

  return (
    <ShareGroupModal
      isOpen={isShareModalGroupPopUp}
      itemToShare={groupNameToBeDelete}
      onClose={handleClose}
      onSuccess={handleClose}
      onShareError={handleClose}
      getUsers={sharingConfig.getUsersForGrouping}
      getShareUserGroups={sharingConfig.getUserGroupsForGrouping}
      namespace={namespace}
      selectedGroupingType={selectedGroupingType}
      addPreferencePermission={addPreferencePermission}
      saveViewFilter={saveViewFilter}
      retailerClients={retailerClients}
    />
  );
};
